import { faUsers, faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';

interface OmniCardProps {
    deviceTypeName: string;
    handleClick: () => void;
}

export class OmniCard extends React.Component<OmniCardProps> {
    constructor(props: OmniCardProps) {
        super(props);
    }

    render() {
        return (
            <div className="panel panel-default" onClick={() => this.props.handleClick()}>
                <div className="panel-body">
                    <div className="col-md-3 text-center">
                        <FontAwesomeIcon icon={faUsers} size="5x" className="text-primary" />
                    </div>

                    <div className="col-md-9">
                        <div className="label label-primary" style={{ lineHeight: 20 + 'px', float: 'right', position: 'absolute', right: -15 + 'px', top: 0 + 'px' }}>
                            <FontAwesomeIcon icon={faWrench} className="text-muted" />
                        </div>
                        <h3>All {this.props.deviceTypeName}</h3>
                    </div>
                </div>
            </div>
        );
    }
}
